'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SimilarItems = require('./SimilarItems.scss');

var _SimilarItems2 = _interopRequireDefault(_SimilarItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItems = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SimilarItems, _Component);

    function SimilarItems() {
        (0, _classCallCheck3.default)(this, SimilarItems);
        return (0, _possibleConstructorReturn3.default)(this, (SimilarItems.__proto__ || (0, _getPrototypeOf2.default)(SimilarItems)).apply(this, arguments));
    }

    (0, _createClass3.default)(SimilarItems, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                headerMessage = _props.headerMessage,
                similarItems = _props.similarItems,
                slider = _props.slider;


            var items = similarItems.length ? similarItems : new Array(6).fill(null);

            var classes = (0, _classnames2.default)(_SimilarItems2.default['similar-items'], className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, slider && similarItems.length ? (0, _jsx3.default)(_components.ItemCardCarousel, {
                className: _SimilarItems2.default['carousel-container'],
                headerMessage: headerMessage,
                index: 0,
                items: items
            }) : [(0, _jsx3.default)('div', {
                className: _SimilarItems2.default['item-ended-similar-items-header']
            }, 'header', (0, _jsx3.default)('h2', {
                className: _SimilarItems2.default['header-text-large']
            }, void 0, headerMessage)), (0, _jsx3.default)(_components.ItemGrid, {
                cardViewModels: items,
                className: _SimilarItems2.default['similar-grid'],
                itemCardClass: _SimilarItems2.default['similar-cards']
            }, 'grid')]);
        }
    }]);
    return SimilarItems;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = SimilarItems;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SimilarItems/SimilarItems.js
// module id = yi49
// module chunks = 46